import { render, staticRenderFns } from "./rkpd_awal.vue?vue&type=template&id=c4e1f4f6&"
import script from "./rkpd_awal.vue?vue&type=script&lang=js&"
export * from "./rkpd_awal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports